<script setup lang="ts">

import Cashback from '@presentation/Icons/Cashback.vue';
import Concierge from '@presentation/Icons/Concierge.vue';
import HealthAssessments from '@presentation/Icons/HealthAssessments.vue';
import HealthMonitoring from '@presentation/Icons/HealthMonitoring.vue';
import Service from '@/modules/Presentation/Icons/Service.vue';
import Reports from '@/modules/Presentation/Icons/Reports.vue';

</script>

<template>
    <div class="flex flex-wrap">
            
        <!-- <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Tyres class="w-10 2xl:w-14 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Tyre Puncture Repair</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Get punctures repaired at no cost, keeping you safe on the road.
            </h2>
        </div>
  
        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <WindscreenRepair class="w-10 2xl:w-14 -top-1 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Windscreen Repair</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Repair chips ensuring your windshield stays roadworthy.
            </h2>
        </div> -->

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4 -top-3">
            <Cashback class="w-10 2xl:w-14 text-[#B5424A] -top-2" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">Carbucks Rewards Program</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Real cash rewards and discounts for using dealer services and lifestyle purchases
            </h2>
        </div>
        
        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4 -top-3">
            <HealthAssessments class="w-10 2xl:w-14 text-[#B5424A]"/>
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">24/7 Health Monitoring</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Active monitoring of the 
                vehicle's health and performance
            </h2>
        </div>
        
        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Service class="w-10 2xl:w-14 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">
                Algorithmic Retention 
            </h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Stays ahead of service schedule and maintenance based on vehicle usage
            </h2>
        </div>
  
        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Reports class="w-10 2xl:w-14 -top-1 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">
                Genuine Automotive Platform
            </h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Handles PROTECT claims, vehicle servicing, V.E.D., insurance and warranties
            </h2>
        </div>

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4 -top-3">
            <HealthMonitoring class="w-10 2xl:w-14 text-[#B5424A]"/>
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Health Assessments</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Complimentary health checks for the vehicle to identify any issues early
            </h2>
        </div>

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4 top-3">
            <Concierge class="w-10 2xl:w-14 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">Dedicated Concierge</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Inbound and outbound personalised assistance to improve retention
            </h2>
        </div>

    </div>

</template>